module.exports = __webpack_public_path__ + "res/img_audio_poster.aaa8066efd8ca52256405054c5850ae7.png";